var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-home",style:(_vm.boxStyle)},[(_vm.loading)?_c('div',{staticClass:"loading"}):_c('div',{staticClass:"container"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.data.image}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }